import { RouterProvider } from 'react-router';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { AuthProvider, NavItemsProvider, TenantSettingsProvider, brandTheme } from '@claim-os/shared';
import { SessionTimeoutProvider } from './session-timeout/components/SessionTimeoutProvider';
import { NAV_ITEMS } from './navConfig';
import { router } from './routes';

export default function App() {
  return (
    <AuthProvider>
      <TenantSettingsProvider>
        <NavItemsProvider items={NAV_ITEMS}>
          <ThemeProvider theme={brandTheme}>
            <CssBaseline />
            <SessionTimeoutProvider>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <RouterProvider router={router} />
              </LocalizationProvider>
            </SessionTimeoutProvider>
          </ThemeProvider>
        </NavItemsProvider>
      </TenantSettingsProvider>
    </AuthProvider>
  );
}
